import React from "react";

const Registration = () => {
  return <section>Registration</section>;
};

export default Registration;
